export default "__VITE_ASSET__B01roDKd__"